import './InfoCard.css';

type InfoCardProps = {
	text: string;
	smallText: string;
	link: string;
	icon: JSX.Element;
};

export const InfoCard = ({ text, smallText, link, icon }: InfoCardProps) => {
	return (
		<div className="info-card-container">
			<a href={link} className="info-card">
				<div className="info-text">
					<div className="small-text">{smallText}</div>
					<div className="main-text">
						{text}
						<span className="link-arrow">→</span>
					</div>
				</div>
				<div className="info-icon">{icon}</div>
			</a>
		</div>
	);
};
